export default {
  女装: "Roupas Femininas",
  男装: "masculino",
  手机和小工具: "Celulares e gadgets",
  居家生活: "vida doméstica",
  电脑及周边设备: "Computadores e equipamentos periféricos",
  美容及个人护理: "Beleza e cuidados pessoais",
  家用电器: "electrodomésticos",
  健康与保健: "saúde e bem estar",
  食品和饮料: "alimentos e bebidas",
  玩具_儿童和婴儿: "brinquedos, crianças e bebês",
  童装时尚: "moda infantil",
  视频游戏: "jogos de vídeo",
  运动与户外: "Esportes e atividades ao ar livre",
  爱好与书籍: "Passatempos e livros",
  相机和无人机: "Câmeras e drones",
  宠物食品及用品: "Alimentos e suprimentos para animais de estimação",
  女士包袋: "bolsas femininas",
  男士包袋: "bolsas masculinas",
  珠宝及配饰: "Joias e Acessórios",
  手表: "assistir",
  女鞋: "Sapatos femininos",
  男装鞋: "sapatos masculinos",
  汽车: "carro",
  我附近的ShopeePay: "ShopeePay perto de mim",
  餐饮_旅行和服务: "Restauração, viagens e serviços",
  旅行及行李: "Viagens e bagagem",
  各种各样的: "Tipos diferentes",
  我是来买什么的: "O que estou aqui para comprar?",
  对不起_找不到_相关的商品:
    "Desculpe, nenhum produto relacionado a [{0}] foi encontrado",
  类别: "categoria",
  产品: "produtos",
  店铺: "comprar",
  首页: "primeira página",
  限时秒杀: "Promoção relâmpago por tempo limitado",
  博客: "blog",
  所有品牌: "Todas as marcas",
  所有类别: "Todas as categorias",
  我的购物车: "meu carrinho de compras",
  发货信息: "informação de entrega",
  交货信息: "Informação de entrega",
  付款: "Pagamento",
  确认: "confirme",
  您的购物车是空的: "Seu carrinho de compras está vazio",
  价格: "preço",
  税: "Imposto",
  数量: "quantidade",
  总计: "total",
  移除: "Remover",
  返回商店: "Voltar para a loja",
  继续发货: "Continuar a enviar",
  筛选: "filtro",
  价格范围: "faixa de preço",
  排序方式: "ordenar por",
  最新: "atualizado",
  最旧: "mais antigo",
  价格从低到高: "Preço de baixo a alto",
  价格从高到低: "Preço de alto a baixo",
  选择交货类型: "Selecione o tipo de entrega",
  送货上门: "Entrega",
  继续付款: "Continuar a pagar",
  任何其他信息: "qualquer outra informação",
  或者: "ou",
  您的钱包余额: "O saldo da sua carteira",
  余额不足: "Saldo insuficiente",
  支付: "pagar",
  我同意: "Concordo",
  条款和条件: "termos e Condições",
  退货政策: "política de devolução",
  隐私政策: "política de Privacidade",
  概括: "generalizar",
  项目: "projeto",
  全部的: "todos",
  小计: "Subtotal",
  总运费: "custo total de envio",
  有优惠码吗_在这里输入: "Existe um código de desconto? entre aqui",
  申请: "Aplicar",
  编辑: "editar",
  删除: "excluir",
  添加新地址: "adicionar novo endereço",
  继续交货信息: "Continuar informações de entrega",
  选择一个地址: "Escolha um endereço",
  购买历史: "Histórico de compras",
  下载: "download",
  已发送退款请求: "Solicitação de reembolso enviada",
  对比: "Comparado",
  对话: "diálogo",
  我的钱包: "Minha bolsa",
  工单: "ordem de serviço",
  管理个人资料: "Gerenciar perfil",
  登出: "sair",
  重置对比列表: "Redefinir lista de comparação",
  您的对比列表为空: "Sua lista de comparação está vazia",
  在您的购物车中: "no seu carrinho de compras",
  在您的愿望清单中: "na sua lista de desejos",
  在您的预定列表中: "na sua lista de reservas",
  下载您的产品: "Baixe seu produto",
  选项: "Opções",
  什么都没找到: "nada encontrado",
  特色产品: "Produtos em destaque",
  最畅销: "Best-seller",
  前_名: "Principais {0}",
  查看更多: "ver mais",
  查看所有类别: "Ver todas as categorias",
  十大品牌: "Dez principais marcas",
  查看所有品牌: "Ver todas as marcas",
  登录: "Conecte-se",
  手机号码: "número de telefone",
  密码: "senha",
  密码长度为6到16个字符: "O comprimento da senha é de 6 a 16 caracteres",
  验证码: "Código de verificação",
  登录中: "Conecte-se",
  游客登录: "Login de visitante",
  注册您的商店: "Cadastre sua loja",
  现在申请: "Aplique agora",
  成为商家: "Torne-se um comerciante",
  现在注册: "Registrar agora",
  登录成功: "Aterrissou com sucesso",
  通知: "notificar",
  未找到通知: "notificação não encontrada",
  评论: "Comente",
  估计运输时间: "Tempo estimado de envio",
  天: "céu",
  所售: "vendido",
  给商家留言: "Deixe uma mensagem para o comerciante",
  规格: "Especificação",
  库存: "em estoque",
  总价: "preço total",
  添加到购物车: "adicionar ao carrinho",
  立即购买: "Compre agora",
  缺货: "fora de estoque",
  添加到愿望清单: "Adicionar a lista de desejos",
  加入对比列表: "Adicionar à lista de comparação",
  退款: "Reembolso",
  查看条款: "Ver termos",
  分享: "compartilhar",
  描述: "descrever",
  相关产品: "produtos relacionados",
  没有人问过商家: "Ninguém perguntou aos comerciantes",
  该产品暂无评论: "Não há comentários para este produto ainda",
  客户评论: "Avaliações de Clientes",
  访问商店: "loja de visita",
  畅销产品: "Mais vendidos",
  日期: "data",
  订单编号: "número do pedido",
  总额: "montante fixo",
  状态: "estado",
  愿望清单: "Lista de Desejos",
  还没有添加任何东西: "Nada foi adicionado ainda",
  注册: "registro",
  邀请码: "Código de Convite",
  请输入邀请码: "Por favor insira o código do convite",
  用户名: "nome de usuário",
  请输入用户名: "por favor insira o nome de usuário",
  用户名长度为6_14个字符:
    "O comprimento do nome de usuário é de 6 a 14 caracteres",
  昵称: "Apelido",
  请输入手机号码: "Por favor insira o número de telefone",
  手机号码格式错误: "Formato errado do número de telefone",
  密码长度为6_16个字符: "O comprimento da senha é de 6 a 16 caracteres",
  确认密码: "Confirme sua senha",
  请输入确认密码: "Por favor insira a senha de confirmação",
  提款密码: "Senha de retirada",
  请输入提款密码: "Por favor insira a senha de saque",
  提款密码长度为4_16个字符:
    "O comprimento da senha de retirada é de 4 a 16 caracteres",
  请输入验证码: "insira o código de verificação",
  在_s后发送: "Enviado após {0}s",
  发送验证码: "Envie o código de verificação",
  注册即表示您同意我们的条款和条件:
    "Ao se inscrever você concorda com nossos termos e condições.",
  创建账号: "Crie a sua conta aqui",
  验证码发送成功: "Código de verificação enviado com sucesso",
  确认密码不一致: "Confirme se a senha é inconsistente",
  提款密码必须为数字: "A senha de saque deve ser numérica",
  注册成功: "Registro bem sucedido",
  购物车: "carrinho de compras",
  账户: "Conta",
  我的账户: "minha conta",
  已经有一个账户: "Já tem uma conta",
  新地址: "novo endereço",
  编辑地址: "Editar Endereço",
  保存: "salvar",
  是否默认: "É o padrão",
  具体地址: "Endereço específico",
  请输入具体地址: "Por favor insira um endereço específico",
  地区: "área",
  请输入地区: "Por favor insira a região",
  城市: "Cidade",
  请输入城市: "Por favor insira a cidade",
  省份: "província",
  请输入省份: "Por favor insira a província",
  邮政编码: "Código postal",
  请输入邮政编码: "Por favor insira o código postal",
  电话号码: "número de telefone",
  请输入电话号码: "Por favor, digite seu número de telefone",
  收货人: "Receptor",
  请输入收货人: "Por favor insira o destinatário",
  保存成功: "Salvo com sucesso",
  最畅销的商家: "Comerciantes mais vendidos",
  查看所有的商家: "Ver todas as empresas",
  支持政策: "Política de suporte",
  您的电子邮件地址: "Seu endereço de email",
  订阅: "inscrição",
  联系方式: "Informações de contato",
  地址: "endereço",
  美国伊利诺伊州霍夫曼庄园: "Hoffman Estates, Illinois, EUA",
  快速链接: "Links Rápidos",
  商家政策: "Políticas do comerciante",
  submit: "enviar",
  提款银行卡: "Retirada de cartão bancário",
  我的面板: "meu painel",
  提示: "dica",
  确定登出吗: "Tem certeza que deseja sair?",
  确定: "Claro",
  取消: "Cancelar",
  项目添加到您的购物车: "Adicione item ao seu carrinho de compras",
  经常一起购买: "muitas vezes compram juntos",
  返回购物: "Voltar às compras",
  进行结算: "fazer o check-out",
  帮助热线: "Linha de apoio",
  查看所有通知: "Ver todas as notificações",
  请输入密码: "Por favor insira a senha",
  前往充值: "Vá para recarregar",
  购物车物品: "Itens do carrinho de compras",
  查看购物车: "verifique o carrinho de compras",
  钱包余额: "saldo da carteira",
  充值钱包: "Recarregar carteira",
  钱包充值_线下_: "Recarga de carteira (off-line)",
  申请提款: "Solicitar saque",
  钱包收支明细: "Detalhes de receitas e despesas da carteira",
  批准: "aprovar",
  提现历史记录: "Histórico de retiradas",
  类型: "tipo",
  信息: "Informação",
  付款方式: "Forma de pagamento",
  请选择付款方式: "Escolha uma forma de pagamento",
  Bill_Type_RECHARGE_BACK: "Recarga de back-end",
  Bill_Type_RECHARGE_ONLINE: "Recarga on-line",
  Bill_Type_RECHARGE_REGISTER: "Cadastre-se gratuitamente",
  Bill_Type_RECHARGE_JACKPOT: "Bônus de recarga",
  Bill_Type_RECHARGE_PRESENT: "Recarregue recompensas",
  Bill_Type_RECHARGE_FROM_COMMISSION: "Transferência de comissão",
  Bill_Type_RECHARGE_TG_COMMISSION: "Comissão de promoção de recarga",
  Bill_Type_REGISTER_TG_COMMISSION: "Comissão de promoção de registro",
  Bill_Type_WITHDRAW: "retirar",
  Bill_Type_WITHDRAW_REJECT: "Retirada rejeitada",
  Bill_Type_DEDUCT_HANDLE: "Dedução manual",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Correção de recarga",
  Bill_Type_MINING_PROFIT: "Renda de mineração",
  Bill_Type_MINING_PROFIT_COMMISSION:
    "Comissão de promoção de renda de mineração",
  Bill_Type_VIP_UPGRADE: "Atualizar VIP",
  Bill_Type_FINANCE_BUY: "Compre produtos financeiros",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Retorno do equilíbrio financeiro",
  Bill_Type_FINANCE_FEE: "Taxas de gestão financeira",
  Bill_Type_FINANCE_PROFIT: "Receita de gestão financeira",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "Comissão para compra de produtos financeiros",
  Bill_Type_FINANCE_PROFIT_COMMISSION:
    "Comissão de receita de produtos financeiros",
  Bill_Type_WHEEL_DRAW: "Loteria de roda gigante",
  Bill_Type_BUY: "comprar mercadorias",
  Bill_Type_PAY_SHOP: "Pague pelo frete",
  Bill_Type_BUY_COMMISSION: "Comissão sobre itens comprados",
  Bill_Type_DEPOSIT: "Pagar depósito",
  Bill_Type_STORE_BUY: "comprar mercadorias",
  Bill_Type_STORE_BUY_REFUND: "Reembolso de produto de compra",
  Bill_Type: "Tipo de alteração de conta",
  Before_Money: "valor anterior",
  Deal_Money: "Valor da alteração da conta",
  After_Money: "Quantidade depois",
  Bill_Time: "Hora de mudança de conta",
  No_More_Data: "não há mais dados",
  Apply_Money: "Valor da aplicação",
  Apply_Time: "tempo de aplicação",
  Withdraw_Info: "Taxa de manuseio: {fee}, chegada: {money}",
  提款订单状态_CHECKING: "Revisão pendente",
  提款订单状态_TRANSFERRING: "Transferindo",
  提款订单状态_PASS: "confirmado",
  提款订单状态_REJECT: "Demitido",
  暂无可用充值方式: "Nenhum método de recarga disponível ainda",
  钱包收款码: "Código de pagamento da carteira",
  钱包地址: "endereço da carteira",
  金额限制: "Limite de valor",
  复制: "cópia de",
  付款凭证: "comprovante de pagamento",
  收款银行: "Banco beneficiário",
  收款人: "Beneficiário",
  收款账号: "Número da conta de pagamento",
  付款银行: "banco de pagamento",
  付款人: "Pagador",
  付款账号: "Conta de pagamento",
  请输入付款银行: "Por favor insira o banco de pagamento",
  请输入付款人: "Por favor insira o pagador",
  请输入付款账号: "Insira o número da conta de pagamento",
  请上传付款凭证: "Por favor carregue o comprovante de pagamento",
  充值金额: "Valor de recarga",
  请输入充值金额: "Insira o valor da recarga",
  submitting: "enviando...",
  Confirm: "enviar",
  Commit_Success: "submetido com sucesso",
  balanceType_BALANCE: "equilíbrio",
  balanceType_COMMISSION: "comissão",
  Balance: "Saldo da conta",
  Wash_Money: "adicionar mosaico",
  请选择银行账户: "Selecione uma conta bancária",
  卡号类型: "Tipo de número do cartão",
  提现金额: "Quantidade retirada",
  提款金额: "Quantidade retirada",
  不能为空: "Não pode estar vazio",
  金额不正确: "O valor está incorreto",
  please_input_withdraw_password: "Por favor insira a senha de saque",
  withdraw_password_format_error:
    "A senha de retirada deve ter de 4 a 16 caracteres",
  Fee: "taxa de manuseio",
  实际到账: "Chegada real",
  交易币种: "Moeda de transação",
  原始密码: "senha original",
  confirm_password_error: "A senha digitada duas vezes está incorreta",
  save_success: "Salvo com sucesso",
  please_input: "Por favor, insira",
  old_password: "Senha Antiga",
  new_password: "Nova Senha",
  please_input_confirm_password: "Por favor confirme a senha novamente",
  没有找到符合条件的商品: "Nenhum produto correspondente encontrado",
  Search: "procurar",
  全部: "todos",
  EnumGoodsOrderState_USER_PAY: "Aguardando entrega",
  EnumGoodsOrderState_SHOP_PAY: "Entregando",
  EnumGoodsOrderState_SUCCESS: "Terminar",
  EnumGoodsOrderState_CANCEL: "Cancelado",
  EnumGoodsOrderState_REFUND_SUCCESS: "devolveu",
  订单号: "número do pedido",
  用户名称: "nome de usuário",
  收益: "renda",
  支付时间: "Prazo de pagamento",
  配送时间: "Prazo de entrega",
  完成时间: "Tempo completo",
  发货: "Enviar",
  全选: "selecionar tudo",
  物品已添加到愿望清单: "Item adicionado à lista de desejos",
  物品已添加到比较列表: "Item adicionado à lista de comparação",
  购买成功提示: "Parabéns, sua compra foi realizada com sucesso",
  订单列表: "Lista de pedidos",
  商品名: "Nome do Produto",
  图片: "foto",
  没有品牌: "sem marca",
  基本信息: "Informação básica",
  Account_Name: "Nome de abertura de conta",
  Bank_Account: "Conta bancária",
  Bank_Phone: "Reservar número de celular",
  IFSC: "Conta IFSC",
  UPI: "Conta UPI",
  PIX: "Conta PIX",
  CPF: "Conta CPF",
  GCASH: "Conta GCASH",
  POWWI: "Conta POWWI",
  身份证号: "número de identidade",
  Edit: "Rever",
  Delete: "excluir",
  Add: "Novo",
  Forget_Withdraw_Password: "Esqueci a senha de saque",
  Bank_Card_Info: "Informações do cartão bancário",
  收款人地址: "Endereço do beneficiário",
  SWIFT: "RÁPIDO",
  Bank_Branch: "Nome da filial",
  分行代码: "Código da Agência",
  银行地址: "endereço do banco",
  Email: "E-mail",
  银行卡长度必须超过: "O comprimento do cartão bancário deve exceder {length}",
  银行卡格式不正确: "O formato do cartão bancário está incorreto",
  Do_you_confirm_delete: "Confirmar exclusão?",
  Please_Login_First: "por favor faça login primeiro",
  Bank_Name: "nome do banco",
  Please_add_bank_first:
    "Você ainda não vinculou seu cartão bancário, adicione-o primeiro",
  withdrawType: "Tipo de retirada",
  withdraw_money_limit:
    "O valor da retirada deve ser maior que 0 e menor ou igual a {balance}",
  withdraw_times_limit:
    "Você retirou {todayWithdrawNum} vezes hoje e uma taxa de processamento de {withdrawFee}% será cobrada após {limitTimes} vezes. Tem certeza de retirar?",
  Copy_Success: "Copiado com sucesso",
  商店首页: "Página inicial da loja",
  所有产品: "Todos os produtos",
  新到货产品: "Produtos recém-chegados",
  所有商家: "Todos os comerciantes",
  请上传: "Por favor carregue",
  请输入: "Por favor, insira",
  忘记密码: "esqueça a senha",
  记得我: "lembre de mim",
  共_件: "Total de {0} itens",
  取消订单: "cancelar pedido",
  申请退款: "Peça um reembolso",
  未知商家: "Comerciante desconhecido",
  到账: "Recibo",
  提款订单状态: "Status do pedido de retirada",
  前_名类别: "Principais {0} categorias",
  取消订单原因_不想要了: "Não quero mais isso",
  取消订单原因_商品错选_多选: "Seleção errada de produtos/seleções múltiplas",
  取消订单原因_商品无货: "Produto fora de estoque",
  取消订单原因_地址信息填写错误:
    "Informações de endereço preenchidas incorretamente",
  取消订单原因_商品降价: "Redução do preço do produto",
  取消订单原因_价格高于其他平台:
    "O preço é mais alto do que outras plataformas",
  取消订单原因_没用_少用_错用优惠:
    "Não uso/menos uso/uso indevido de descontos",
  退款原因_拍错_多拍_不喜欢: "Tiro errado / tiro extra / não gosto",
  退款原因_商品成分描述不符:
    "A descrição do ingrediente do produto não corresponde",
  退款原因_与商家协商一致退款: "Reembolso conforme acordado com o comerciante",
  退款原因_生产日期_保质期与商品描述不符:
    "A data de produção/prazo de validade não corresponde à descrição do produto",
  退款原因_图片_产地_批号_规格等描述不符:
    "Imagens/origem de origem/número do lote/especificações e outras descrições não correspondem",
  退款原因_质量问题: "Problemas de qualidade",
  退款原因_商品变质_发霉_有异物:
    "O produto está estragado/mofado/contém corpos estranhos",
  退款原因_少件_含缺少配件_: "Poucas peças (incluindo acessórios faltantes)",
  退款原因_收到商品时有破损_污渍_变形:
    "O item estava danificado/manchado/deformado quando recebido.",
  退款原因_假冒品牌: "Marcas falsificadas",
  退款原因_发票问题: "Problemas de fatura",
  退款原因_商家发错货: "O comerciante enviou a mercadoria errada",
  退款原因_预约不到_商家不给退换:
    "Não é possível marcar uma consulta/o comerciante não aceita devoluções ou trocas",
  退款失败: "Falha no reembolso",
  退款处理中: "Reembolso em andamento",
  默认: "padrão",
  产品查询: "Pesquisa de produtos",
  商店LOGO: "LOGOTIPO DA LOJA",
  推广码: "Código de promoção",
  查看所有: "ver tudo",
  确认收货成功: "Confirme o recebimento de mercadorias com sucesso",
  物流公司: "Empresa de logística",
  物流单号: "número de envio",
  发货时间: "Prazo de entrega",
  请先选择商品规格: "Selecione as especificações do produto primeiro",
  个人信息: "informações pessoais",
  您的用户名: "seu nome de usuário",
  你的名字: "seu nome",
  登录名: "nome de usuário",
  你的邮件: "seu email",
  你的密码: "sua senha",
  重复输入密码: "Repita a senha",
  店铺名称: "Nome da loja",
  证书类型: "Tipo de certificado",
  身份证: "carteira de identidade",
  护照: "Passaporte",
  驾驶执照: "carteira de motorista",
  社会保障卡: "Cartão de segurança social",
  证书正面: "Frente do certificado",
  证书反面: "Verso do certificado",
  确认收货: "confirmar o recebimento de mercadorias",
  请选择取消订单的原因必选:
    "Selecione o motivo do cancelamento do pedido (obrigatório):",
  请选择申请退款的原因必选:
    "Selecione o motivo da solicitação de reembolso (obrigatório):",
  留言: "mensagem",
  请输入留言: "Por favor, digite uma mensagem",
  没有帐户: "Nenhuma conta",
  钱包充值: "Recarga de carteira",
  输入您的文字: "Digite seu texto",
  商家登录: "Login do comerciante",
  有关此产品的任何查询: "Qualquer dúvida sobre este produto",
  产品名称: "Nome do Produto",
  你的问题: "seu problema",
  白银店铺: "loja de prata",
  铂金店铺: "loja de platina",
  钻石店铺: "loja de diamantes",
  照片: "foto",
  已退货: "Devolvida",
  邮寄状态: "Status de correspondência",
  订单摘要: "Resumo do pedido",
  收件地址: "Endereço do destinatário",
  订购日期: "Data do pedido",
  订单状态: "Status do pedido",
  总订单金额: "Valor total do pedido",
  邮寄方式: "Método de envio",
  附加信息: "Informações adicionais",
  订单详细信息: "Detalhes do pedido",
  交货类型: "Tipo de entrega",
  进行评论: "Faça um comentário",
  已评论: "Comentado",
  订单金额: "Valor do pedido",
  优惠券: "cupom",
  统一运费: "Taxa fixa de envio",
  送货地址: "Endereço para envio",
  评分: "pontuação",
  你的意见: "sua opinião",
  匿名: "anônimo",
  现金: "dinheiro",
  详情: "Detalhes",
  收货地址: "Endereço para envio",
  暂时没有对话: "Nenhuma conversa ainda",
  你: "você",
  输入您的回复: "Digite sua resposta",
  删除成功: "excluído com sucesso",
  品牌: "marca",
  已缴纳的保证金: "Caução paga",
  黄金店铺: "loja de ouro",
  没有更多数据: "não há mais dados",
  站内信: "Mensagem do site",
  系统通知: "notificação do sistema",
  邮箱: "Correspondência",
  手机号: "Número de telefone",
  你的手机号: "seu número de telefone",
  营业执照: "alvará de funcionamento",
  你的邮箱: "sua caixa de correio",
  搜索结果: "Procurar Resultados",
  系统公告: "notificação do sistema",
  客服: "atendimento ao Cliente",
  消息已撤回: "A mensagem foi retirada",
  物流详情: "Detalhes logísticos",
  充值: "completar",
  提现: "retirar",
  信用分: "pontuação de crédito",
  余额: "equilíbrio",
  佣金: "comissão",
  继续购物: "continue comprando",
  订单结算: "Liquidação de pedidos",
  加入对比: "Adicionar à comparação",
  佣金余额: "Saldo da comissão",
  刷新: "atualizar",
  刷新成功: "Atualização bem-sucedida",
  官网: "Website oficial",
  税号: "Número de identificação fiscal",
  订单: "Ordem",
  合计: "total",
  系统安全: "Segurança do sistema",
  Recharge_Money_Limit: "O valor da recarga deve estar entre {min} e {max}",
  限时优惠: "Oferta por tempo limitado",
  高价回收: "Reciclagem de alto preço",
  姓名: "Nome",
  商品订单号: "Número do pedido do produto",
  商品在线回收: "Reciclagem on-line de produtos",
  提交: "enviar",
  回收记录: "Registros de reciclagem",
  回收状态: "Status de reciclagem",
  回收价格: "preço de reciclagem",
  纳税码: "código fiscal",
  买家登录: "Conecte-se",
  买家注册: "registrar",
  语言: "葡萄牙语",
  language: "chinês",
  助力提示:
    "Ajudar os comerciantes a aumentar a exposição da plataforma às suas lojas e quanto maior o número cumulativo de dias, maior a exposição.",
  已累计助力: "Assistido cumulativamente",
  今日已助力: "Hoje ajudou",
  立即助力: "Ajudar imediatamente",
  商家助力: "Ajuda do comerciante",
  证件号码: "Número de identificação",
  证书号码: "Número do certificado"
};
